export const initialCompanyUsersState = {
  loggedUser: null,
};

export interface ICompanyUsersState {
  loggedUser: any
}


